<template>
    <div v-if="emails.length>0" class="container">
        <br /><br />
        <div class="jumbotron">
            <h1 class="display-4">Sharing {{resourceName}}</h1>
            <p class="lead">Send notification for shared <strong>{{resourceName}}</strong> owned by <strong>{{organizationName}}</strong> data in TransparentChoice application</p>
            <br />

            <div v-for="e in emails" class="form-check form-check-inline">
                <input v-model="selectedEmails" class="form-check-input" type="checkbox" :id="`email_${e}`" :value="e">
                <label class="form-check-label" :for="`email_${e}`">{{e}}</label>
            </div>
            <br /><br />

            <textarea v-model="message" class="form-control" placeholder="Optianal message here"></textarea>
            <br /><br />

            <a :href="`/#/sharing/resource/${resourceProviderName}/${resourceId}`" class="btn btn-lg btn-secondary m-1" :disabled="invokingSendNotificationCommandV1">Skip</a>
            <button @click="invokeSendNotificationCommandV1" class="btn btn-lg btn-primary pull-right m-1" :disabled="selectedEmails.length==0 || invokingSendNotificationCommandV1">Send</button>

            <div v-show="succeedSendNotificationCommandV1" class="alert alert-primary mt-5" role="alert">
                <span>Notification was sent successfully</span>
                <a :href="`/#/sharing/resource/${resourceProviderName}/${resourceId}`"><strong>Close</strong></a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from 'vue-router'
    import { useShareNotificationPage } from '@DataSharing/Shares/pages-core'
    import ValidationError from "@common/Components/ValidationError.vue";

    document.title = 'Share data'

    const route = useRoute()
    const shareId = route.params.shareId

    const selectedEmails = ref([])
    const message = ref('')

    const organizationName = computed(() => modelShareNotificationQueryV1.value?.OrganizationUnitName)
    const workspaceName = computed(() => modelShareNotificationQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelShareNotificationQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelShareNotificationQueryV1.value?.ResourceName)
    const resourceUrl = computed(() => modelShareNotificationQueryV1.value?.ResourceUrl)
    const resourceProviderName = computed(() => modelShareNotificationQueryV1.value?.ResourceProviderName)
    const resourceId = computed(() => modelShareNotificationQueryV1.value?.ResourceId)
    const emails = computed(() => modelShareNotificationQueryV1.value?.Emails || [])

    const { useShareNotificationQuery, useSendNotificationCommand } = useShareNotificationPage()

    const { modelShareNotificationQueryV1, runShareNotificationQueryV1, succeed } = useShareNotificationQuery(shareId)

    const { invokeSendNotificationCommandV1, succeedSendNotificationCommandV1, invokingSendNotificationCommandV1 } = useSendNotificationCommand(shareId, message, selectedEmails)

    onMounted(() => runShareNotificationQueryV1())

    watch(succeed, () => {
        if (emails.value.length == 0) {
            navigateToResourceSharePage()
        }
    })

    function navigateToResourceSharePage() {
        location.href = `/#/sharing/resource/${resourceProviderName.value}/${resourceId.value}`
    }
</script>
